import { appUrl } from "@/utils/app-url";
import { Path as PathPages, buildPaths as buildPagesPaths } from "./$path";
import {
  Path as PathRoute,
  buildPaths as buildRoutePaths,
} from "./$route-path";

export type PagesPath = PathPages;
/** @knipignore */
export type RoutePath = PathRoute;

export const pagesPath = buildPagesPaths(appUrl);
export const routePath = buildRoutePaths(appUrl);
